export default {
    RTTB: 'Прокрутка вниз'
}